export default {
  title: "Work Orders",

  work_order_corrective: "Work Order, Corrective",
  work_order_regular: "Work Order, Regular",

  overview: "Overview",
  issues: "Issues",
  items: "Items",
  attached: "Attached",
  comments: "Comments",

  priority: "Priority",
  deadline: "Deadline",

  reference: "Reference",
  designation: "Designation",
  work_domain: "Work domain",
  work_instructions: "Work Instructions",
  time_requirements: "Time requirements",
  material_requirements: "Material requirements",

  section_assigned: "Assigned",
  section_managed: "Managed",
  section_closed: "Closed",

  work_performed: "Performed",
  work_performed_count: "Performed ({count} <span class='text-quote-text'>/</span> {totalCount})",
  work_not_performed: "Not Performed",
  work_not_performed_count:
    "Not Performed ({count} <span class='text-quote-text'>/</span> {totalCount})",
}
